import React, {useEffect} from 'react';
import {addCompany, getAllUsers} from '../../../services/AdminService'
import DropdownButton from 'react-bootstrap/DropdownButton'
import {Dropdown} from 'react-bootstrap';
import {Form} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {Alert} from 'react-bootstrap';
import LoadingLoginScreen from '../../../components/LoadingLoginScreen';

export const AddCompany = () => {


    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const companyRef = React.useRef("");
    const amountOfAccountsRef = React.useRef(0);




    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!companyRef.current.value) {
            setError(true);
            setErrorText("Ange företag")
            return;
        } else if (!amountOfAccountsRef.current.value) {
            setError(true);
            setErrorText(`Hur många licenser ska ${companyRef.current.value}?`);
            return;

        } else {

            try {
                setLoading(true);
                await addCompany(
                    companyRef.current.value,
                    amountOfAccountsRef.current.value).then(() => {
                    setError(true);
                    setErrorText(`Företag tillagt.`)
                }).catch((err) => {
                    setError(true);
                    setErrorText(err);
                });
                setLoading(false)
            } catch (e) {
                console.error(e)
            }
        }

        setLoading(false)

    }


    return (
        <>
            {loading ? <LoadingLoginScreen/> :
                <Form
                    onSubmit={handleSubmit}
                    style={{padding: "30px", margin: " 30px"}}

                >

                    {error ? <Alert variant='success'>
                        {errorText}
                    </Alert> : null}


                    <Form.Group className="mb-3">
                        <Form.Label>Företagsnamn</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Leadtub AB"
                            ref={companyRef}
                        />
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>Antal licenser hos </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="12"
                            ref={amountOfAccountsRef}
                        />
                    </Form.Group>


                    <Button variant="primary" type="submit">
                        Skapa Företag
                    </Button>
                </Form>
            }
        </>
    )
}
